import {useState} from 'react'
import {css} from '@emotion/react'
import {exactMatch, Tree} from '@/components/Tree'
import {useMapContext} from '@/components/MindMap/index.mjs'
import ButtonsReplace from './ButtonsReplace.jsx'
import {InputReplace, InputSearch} from './inputs.jsx'
import useTreeData from './useTreeData.mjs'

const cssPane = css({
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '100%',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
})

const cssSearchReplace = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    backgroundColor: '#fff',
    padding: 12,
    borderBottom: '1px solid #e8e8e8',
})

const cssTree = css({
    fontSize: 12,
})

export default function SearchPane(props) {
    const map = useMapContext()
    const data = useTreeData(map)
    const [textSearch, setTextSearch] = useState('')
    const [textReplace, setTextReplace] = useState('')
    const [targetId, setTargetId] = useState('')
    const [matchedIds, setMatchedIds] = useState([])

    const onMatch = matches => {
        setMatchedIds(matches.map(e => e.id))
        setTargetId('')
    }

    const onSelect = ({id}) => {
        const node = map.getNode(id)
        map.execute(() => map.selectNodes([node]))
        setTargetId(id)
    }

    return (
        <div
            css={cssPane}
            {...props}
        >
            <div css={cssSearchReplace}>
                <InputSearch onChange={setTextSearch} />

                <InputReplace
                    textSearch={textSearch}
                    onChange={setTextReplace}
                />

                <ButtonsReplace
                    matchedIds={matchedIds}
                    targetId={targetId}
                    textReplace={textReplace}
                    textSearch={textSearch}
                />
            </div>

            <Tree
                css={cssTree}
                data={data}
                defaultExpandAll
                match={exactMatch}
                searchText={textSearch}
                onMatch={onMatch}
                onSelect={onSelect}
            />
        </div>
    )
}
